import { useState } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import * as RadixToggleGroup from "@radix-ui/react-toggle-group";
import styles from "./styles.module.scss";

type ToggleGroupOption = {
  value: string;
  label: string;
};

interface ToggleGroupProps {
  defaultOption?: ToggleGroupOption;
  options: Array<ToggleGroupOption>;
  onChange: (value: string) => void;
}

export const ToggleGroup = ({
  options,
  defaultOption,
  onChange,
}: ToggleGroupProps) => {
  const [block, cn] = useModuleBEM(styles, "ToggleGroup");

  const { value: defaultValue } = defaultOption || options[0];
  const [selectedOption, setSelectedOption] = useState<string>(defaultValue);

  const onToggleChange = (value) => {
    const selectedValue = value !== "" ? value : selectedOption;

    setSelectedOption(selectedValue);
    onChange(selectedValue);
  };

  return (
    <div className={block}>
      <RadixToggleGroup.Root
        className={cn("container")}
        type="single"
        defaultValue={defaultValue}
        onValueChange={onToggleChange}
      >
        {options.map(({ label, value }) => (
          <RadixToggleGroup.Item
            className={cn("categoryButton", {
              selected: selectedOption === value,
            })}
            key={label}
            value={value}
            aria-label={label}
          >
            {label}
          </RadixToggleGroup.Item>
        ))}
      </RadixToggleGroup.Root>
    </div>
  );
};
